/* eslint-disable no-unused-vars */
import React, { useState, useRef, useContext, useEffect } from 'react';
// eslint-disable-next-line no-unused-vars
import styled from 'styled-components/macro';
import AvatarEditor from 'react-avatar-editor';
import { useMediaPredicate } from 'react-media-hook';
import { useParams } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import Button from '../../atoms/Button';
import logoImg from '../../../assets/images/logo-small.svg';
import logoImg1 from '../../../assets/images/plastk-logo.svg';
import bgImg from '../../../assets/images/banner-bg.jpg';
import ModalContainer from '../../molecules/ModalContainer';
import BusinessInformationModal from '../BusinessInformationModal';
import { Banner, ImgBox, RightColumn, Logo, BtnWrap, IconHolder } from './BannerBlock.style';
import { AuthContext } from '../../../context/authContext';
import { getCookie, showEditCardModal } from '../../../helpers/common';
import CardInfo from '../CardInfoForm';
import UserService from '../../../services/userService';
import Toast from '../../molecules/Toast';
import Loaders from '../../atoms/Loaders';
import { PageButtons } from '../../../helpers/headerButtons';
import { LoadingContext } from '../../../context/loadingContext';
import ButtonsNav from '../ButtonsNav';

function BannerBlock({ profilePage }) {
  const { isLoading } = useContext(LoadingContext);
  const { view } = useParams();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const buttons = PageButtons[profilePage] ?? [];

  const { hasPermission, user, refetch, showStoreModal, setShowStoreModal, setShowKickOffUpload } =
    useContext(AuthContext);
  const MinWidth1200 = useMediaPredicate('(min-width: 1200px)');
  const RangeWidth = useMediaPredicate('(min-width: 992px) and (max-width: 1199.98px)');
  const MaxWidth991 = useMediaPredicate('(max-width: 991px) ');
  const ButtonsSkeleton = () => (
    <>
      {MinWidth1200 && <Skeleton rectangle height={46} width={173} css="border-radius:75px !important;" />}
      {RangeWidth && <Skeleton circle height={46} width={46} />}
      {MaxWidth991 && <Skeleton circle height={18} width={18} />}
    </>
  );

  // useEffect(() => {
  //   if (active) {
  //     document.body.classList.add('list-active');
  //   }
  // }, [active]);

  const MaxWidth767 = useMediaPredicate('(max-width: 767px)');
  const MinWidth768 = useMediaPredicate('(min-width: 768px)');
  // const { user, hasPermission } = useContext(AuthContext);
  const [state, setState] = useState({ ...user?.cardInfo });
  const [isClosable, setIsClosable] = useState(true);
  const [reposition, setReposition] = useState(false);
  const [loading, setLoading] = useState(false);
  const [origionalImage, setorigionalImage] = useState();
  const [myBanner, setMyBanner] = useState(
    user?.attachments?.new_banner_img
      ? `${user?.attachments?.new_banner_img?.cloudinary_url}?${new Date().getTime()}`
      : user?.attachments?.banner_img?.cloudinary_url,
  );

  const editor = useRef(null);

  const getImgBase64 = async () => {
    try {
      setLoading(true);
      const data = await UserService.getBanner();
      setorigionalImage(data?.base64);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setReposition(false);
    }
  };
  const handleReposition = async () => {
    setReposition(!reposition);
    getImgBase64();
    // setorigionalImage(newBannerImg);
  };
  const handleSave = async e => {
    const image = editor.current.getImageScaledToCanvas().toDataURL();
    setLoading(true);
    await UserService.updateBannerImage({ banner_img: image, new_banner_img: origionalImage })
      .then(res => {
        setMyBanner(res?.image);
        Toast({
          type: 'success',
          message: 'Profile updated successfully',
        });
      })
      .catch(ex => {
        Toast({
          type: 'error',
          message: ex.message,
        });
      })
      .finally(() => setLoading(false));

    setReposition(false);
  };

  useEffect(() => {
    const banner = user?.attachments?.new_banner_img
      ? `${user?.attachments?.new_banner_img?.cloudinary_url}?${new Date().getTime()}`
      : user?.attachments?.banner_img?.cloudinary_url;
    setMyBanner(banner);
  }, [user]);
  return (
    <>
      <Loaders loading={loading}>
        <Banner
          // key={Math.random()}
          profilePage={profilePage}
          css={
            !reposition &&
            `
            background-image: url(${myBanner});
            position: relative;
          `
          }>
          {reposition && (
            <ImgBox>
              <AvatarEditor
                style={{ marginTop: '-1.5%' }}
                ref={editor}
                image={origionalImage}
                width={1540}
                height={210}
                border={1}
                color={[255, 255, 255, 0.6]}
                scale={1.08}
                rotate={0}
              />
            </ImgBox>
          )}
          {!profilePage && !reposition && (
            <ImgBox>
              <img
                src={
                  user?.attachments?.business_logo?.cloudinary_url
                    ? `${user?.attachments?.business_logo?.cloudinary_url}?${new Date().getTime()}`
                    : logoImg
                }
                width="140"
                alt="img-description"
              />
            </ImgBox>
          )}
          {MinWidth768 && (
            <>
              {!reposition && (
                <RightColumn>
                  <Logo href="/" style={{ marginRight: '30px' }}>
                    <img src={logoImg1} width="120" height="48" alt="plastk" />
                  </Logo>
                  <BtnWrap>
                    {hasPermission('bap.dashboard.update-card-details') &&
                      user?.role === 'bp_user' &&
                      showEditCardModal(user) && (
                        <ModalContainer
                          title="Update Card Details"
                          width="1000"
                          isClosable={isClosable}
                          btnComponent={({ onClick }) => (
                            <Button
                              type="white"
                              sm
                              rounded
                              suffix={<span className="icon-pencil" />}
                              onClick={() => {
                                onClick();
                              }}>
                              Update Card Details
                            </Button>
                          )}
                          content={({ onClose }) => (
                            <CardInfo
                              onClose={onClose}
                              state={state}
                              setState={setState}
                              type="edit"
                              action="update"
                              setIsClosable={setIsClosable}
                            />
                          )}
                        />
                      )}

                    {hasPermission('bap.dashboard.edit-business-details') && user?.role === 'bp_user' && (
                      <ModalContainer
                        title="Update Business Information"
                        xl
                        btnComponent={({ onClick }) => (
                          <Button
                            type="white"
                            sm
                            rounded
                            width="220"
                            suffix={<span className="icon-pencil" />}
                            onClick={() => {
                              onClick();
                            }}>
                            Edit Business Details
                          </Button>
                        )}
                        content={({ onClose }) => <BusinessInformationModal onClose={onClose} />}
                      />
                    )}
                  </BtnWrap>
                </RightColumn>
              )}
            </>
          )}
          {reposition && (
            <IconHolder>
              <Button
                type="white"
                style={{
                  width: '15px',
                  height: '39px',
                  borderRadius: '50%',
                }}
                sm
                rounded
                suffix={<span className="icon-tick" style={{ fontSize: '14px', marginRight: '10px' }} />}
                onClick={handleSave}
              />
              <Button
                type="white"
                style={{
                  width: '15px',
                  height: '39px',

                  borderRadius: '50%',
                }}
                sm
                rounded
                suffix={<span className="material-icons-outlined">clear</span>}
                onClick={() => {
                  setReposition(false);
                }}
              />
            </IconHolder>
          )}
          {/* {!reposition && (
            <Button
              type="white"
              style={{ width: '33px', height: '33px', position: 'relative', bottom: '10px', padding: '0' }}
              sm
              rounded
              suffix={<span className="icon-pencil" style={{ fontSize: '14px', marginRight: '10px' }} />}
              onClick={handleReposition}
            />
          )} */}

          {MaxWidth767 && <ButtonsNav />}
        </Banner>
      </Loaders>
    </>
  );
}

export default BannerBlock;
